
<template>
    <div class="inner sulution-container">
        <!-- <iframe src="/user/static/game/1stroop/index.html" height="100%" width="100%" style="border:none"></iframe> -->
        <span><v-img :src="this.$fileUrl(24341)"></v-img></span>
        <span><v-img :src="this.$fileUrl(24342)"></v-img></span>
        <span><v-img :src="this.$fileUrl(24344)"></v-img></span>

        <FooterBtns/>
        <!-- <FooterBtnsNext v-if="step !== 11" @before="before" @next="next" :current="current" :total="total" :disabledNext="disabledNext"/> -->

        <a class="kakao" @click="sendkakao">카카오톡</a>
        <input type="file" accept="image/*" @change="upload"/>
    </div>
</template>

<script>
import store from '../store'
import FooterBtns from "@/components/btns/FooterBtns"
//import FooterBtnsNext from "@/components/btns/FooterBtnsNext"
export default {
  data: ()=> ({
    step: 1,
    total: 4,
    sheet: false,
    testResult: '',
    pathVariableTestInnerResult: {},
    pathVariableTestResult: {},
    errPathVariableTestResult: {},
    getUnitManageListResult: {},
    files:{},
    kakaoImgUrl: '',
  }),
  components:{
    FooterBtns,
    //FooterBtnsNext
  },
  computed: {
    progress (){
      return (100 / this.total)  * this.step;
    }
  },
  created () {
    this.dataInit()
  },
  methods:{
    upload(file) {
      this.files= file.target.files
      console.log('11'+this.files)

      window.Kakao.Share.uploadImage({
        file: this.files,
        })
        .then(function(response) {
          console.log(response.infos.original.url);
          alert(response.infos.original.url)
          //this.kakaoImgUrl = response.infos.original.url
        })
        .catch(function(error) {
          console.log(error);
        })
        ;
    },
    sendkakao: function () {
      window.Kakao.Share.sendCustom({
        templateId: 88619,
        templateArgs: {
          title: '노트 이미지 공유',
          description: '노트 이미지 공유',
          THU: 'http://k.kakaocdn.net/dn/iuOaJ/bl3UTtpvYkW/7Z1ju4h9iWmtVxHwLjUOkk/kakaolink40_original.png'
        },
      });
    },
    sheetStatus(){
      this.sheet = !this.sheet;
    },
    next(){
      this.step += 1;
    },
     async dataInit () {
    //   await store.dispatch('getTestApi')
    //     .then(res => {
    //       console.log('Gate(정상)1', res)
    //       if (res.success) {
    //         this.testResult = res.data
    //       } else {
    //         console.log(res.msg)
    //         this.testResult = ''
    //       }
    //     })
    //     .catch(error => {
    //       console.error(error)
    //       this.testResult = ''
    //     })
    //     .finally(() => {})


      // 정상적인 코드 호출 (외부 Gateway)
      await store.dispatch('getTestPathVariable', this.$_payload({testCode: 'test1'}))
        .then(res => {
          if (res.success) {
            this.pathVariableTestResult = res.data
          } else {
            console.log(res.msg)
            this.pathVariableTestResult = ''
          }
        })
        .catch(error => {
          console.error(error)
          this.pathVariableTestResult = ''
        })
        .finally(() => {})

      // 비정상 코드 호출
      // await store.dispatch('getTestPathVariable', this.$_payload({testCode: 'test3'}))
      //   .then(res => {
      //     console.log('비정상', res)
      //     if (res.success) {
      //       this.errPathVariableTestResult = res.data
      //     } else {
      //       console.log(res.msg)
      //       this.errPathVariableTestResult = ''
      //     }
      //   })
      //   .catch(error => {
      //     console.error(error)
      //     this.errPathVariableTestResult = ''
      //   })
      //   .finally(() => {})

      // 정상적인 코드 호출 (외부 Gateway)
      // await store.dispatch('getUnitManageList', this.$_payload('unit',[{unitNo:'1'},{unitNm:'TEST'}]))
      //   .then(res => {
      //     console.log('Gate(정상)3', res)
      //     if (res.success) {
      //       this.getUnitManageListResult = res.data
      //     } else {
      //       console.log(res.msg)
      //       this.getUnitManageListResult = ''
      //     }
      //   })
      //   .catch(error => {
      //     console.error(error)
      //     this.getUnitManageListResult = ''
      //   })
      //   .finally(() => {})

      // 정상적인 코드 호출 (외부 Gateway)
      // await store.dispatch('setSquareCmntRegist', this.$_payload('ba',{cmntNo:'22222222222', content:'contentcontent'}))
      //   .then(res => {
      //     console.log('Gate(정상)4', res)
      //     if (res.success) {
      //       this.getUnitManageListResult = res.data
      //     } else {
      //       console.log(res.msg)
      //       this.getUnitManageListResult = ''
      //     }
      //   })
      //   .catch(error => {
      //     console.error(error)
      //     this.getUnitManageListResult = ''
      //   })
      //   .finally(() => {})

       // 정상적인 코드 호출 (외부 Gateway)
      // await store.dispatch('getUnit', this.$_payload({unitNo: '1'}))
      //   .then(res => {
      //     console.log('Gate(정상)4', res)
      //     if (res.success) {
      //       this.getUnitManageListResult = res.data
      //     } else {
      //       console.log(res.msg)
      //       this.getUnitManageListResult = ''
      //     }
      //   })
      //   .catch(error => {
      //     console.error(error)
      //     this.getUnitManageListResult = ''
      //   })
      //   .finally(() => {})

      /**
       * payload 생성시 참고사항 *
       * 설명 : 공통으로 payload를 생성해서 axios 통신시 파라미터로 전달하는 용도
       * key : URL에 PathVariable이 있는 경우 사용 (key는 PathVariable 명칭과 일치)
       * params : Api 호출 시 전달 파라미터
       *  GET, DELETE 호출 시 파라미터는 리스트 in 오브젝트([{}])로 전달
       *    예시 > [ { keyword: '테스트' }, { searchDate: '20220323' }... ]
       *  POST, PUT 호출 시 파라미터는 오브젝트({})로 전달
       *    예시 > { keyword: '테스트', searchDate: '20220323'... }
       *
       * Rest Api 생성 규칙에 의거해 공통 payload 작성됨
       * Mapping URL 생성시 PathVariable 최대 1개만 사용
       */
    }
  },

}
</script>

<style lang="scss" scoped>
.recording{
  position: relative;
  text-align: center;
  padding-top: 40px;
  margin: 100px 0 50px 0;
  .tooltip{
    position: absolute;
    top:0;
    left: 50%;
    margin-left: -45px;
    display: inline-block;
    width: 90px;
    height: 32px;
    line-height: 27px;
    font-size: 11px;
    color: #fff;
    background-image: url(data:image/svg+xml;base64,ICA8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjkwIiBoZWlnaHQ9IjMxLjc2MyIgdmlld0JveD0iMCAwIDkwIDMxLjc2MyI+DQogICAgPGcgaWQ9Iuq3uOujuV8xNjgyMyIgZGF0YS1uYW1lPSLqt7jro7kgMTY4MjMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzUgLTQ5OSkiPg0KICAgICAgPGcgaWQ9Iuq3uOujuV8xNjQwMCIgZGF0YS1uYW1lPSLqt7jro7kgMTY0MDAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00OC45OTkgLTEwMikiPg0KICAgICAgICA8cGF0aCBpZD0i7ZWp7LmY6riwXzE3IiBkYXRhLW5hbWU9Iu2Vqey5mOq4sCAxNyIgZD0iTTcyMTAuNDI3LDExMjc1bC0zLjkyNi01SDcxNjlhMiwyLDAsMCwxLTItMnYtMjJhMiwyLDAsMCwxLDItMmg4NmEyLDIsMCwwLDEsMiwydjIyYTIsMiwwLDAsMS0yLDJoLTM3LjVsLTMuOTI0LDVhMiwyLDAsMCwxLTMuMTQ3LDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjk4MyAtMTA2NDMpIi8+DQogICAgICA8L2c+DQogICAgPC9nPg0KICA8L3N2Zz4=)
  }
  .btn-recording{
    position: relative;
    width: 76px;
    height: 76px;
    border-radius: 50%;
    background: #F5F5F5;
    span{
      position: absolute;
      width: 26px;
      height: 26px;
      border-radius: 560%;
      background: var(--v-primary-base);
    }
  }
}

</style>
